<!--  -->
<template>
    <div v-loading="loading" class='brandshow'>
      <!-- <img src="@/assets/透明猪.png" style="width:40%;height:65%;position:fixed;z-index:50;top:35%;"/> -->
      <el-button class="htmlBack" type="info" plain @click="$router.push('/brandInformation/index')"><i class="el-icon-arrow-left"></i>返回</el-button>
      <!-- <div v-if="htmlData==undefined||htmlData=={}" style="text-align:center;font-size:20px;color:brown;margin-top:80px">
         {{ message }}
      </div> -->
      <div class="content">
        <div class="ht">
          <h1 class="htmlTitle">{{htmlData.title}}</h1>
          <h2 class="htmlTime">发布时间: {{(htmlData.createTime||'').split(" ")[0].replace(RegExp("-","g"),".")}}<i class="el-icon-view" style="margin-left: 1%;"> {{ htmlData.num==undefined||htmlData.num==null?0:htmlData.num }}</i></h2>
        </div>
        <div :style="'backgroundColor:'+htmlData.backgroundColor" class="html" v-html="sanitizedHtml"></div>
        <el-backtop target=".brandshow" :bottom="100" :visibility-height="50"></el-backtop>
      </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {queryHtml} from '@/api/web/brandInformation'
// import {loadingTime} from '@/utils/const.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
 htmlData:{},
//  message:"请稍等,资讯信息加载中......"
 loading:true
};
},
//监听属性 类似于data概念
computed: {
  sanitizedHtml(){
    if(!this.htmlData.html) return ''
    return this.htmlData.html.replace(/<img([^>]*)\ssrc=(["'])(undefined|\s*)\2([^>]*)>/gi, '<img$1 src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" $4>').replace(/<img([^>]*)\ssrc=""([^>]*)>/gi, '<img$1 src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" $2>')
  }
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  var _this = this
  // setTimeout(()=>{
  //   if(_this.htmlData==undefined||_this.htmlData=={}){
  //      _this.message="资讯信息加载失败,请刷新页面重试"
  //   }
  // },loadingTime)
  queryHtml({id:_this.$route.params.id}).then(({data})=>{
    _this.htmlData=data
    if(Object.keys(_this.htmlData).length==0||_this.htmlData==undefined||_this.htmlData==null){
      _this.$message.error("资讯信息加载失败,请刷新页面重试!")
    }
    _this.loading=false
  },()=>{
    _this.$message.error("资讯信息加载失败,请刷新页面重试!")
    _this.loading=false
  })
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {
  //用于解决视频无法居中的问题
  var videos = document.getElementsByTagName('video')
  for(var i=0;i<videos.length;i++){
    videos[i].parentNode.style.textAlign="center"
  }
}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
// .brandshow video{
//   width:100%;
//   opacity: 0.95;
// }
// .brandshow img{
//   width:100%;
//   opacity: 0.95;
// }
.brandshow{
  height:100%;
  overflow: auto;
  background-color: rgb(239, 243, 245);
  // background-color: rgb(223, 240, 247);
  // background:
  //   radial-gradient(circle, transparent 20%, slategray 20%, slategray 80%, transparent 80%, transparent),
  //   radial-gradient(circle, transparent 20%, slategray 20%, slategray 80%, transparent 80%, transparent) 50px 50px,
  //   linear-gradient(#A8B1BB 8px, transparent 8px) 0 -4px,
  //   linear-gradient(90deg, #A8B1BB 8px, transparent 8px) -4px 0;
  //   background-color: slategray;
  //   background-size:100px 100px, 100px 100px, 50px 50px, 50px 50px;

}
.content{
  width:80%;
  margin-left:10%;
  position: relative;
  z-index: 100;
  margin-top:20px;
  padding-top:10px;
  
  @media screen and (max-width: 768px) {
    width: 95%;
    margin-left: 2.5%;
    margin-top: 60px;
  }
}
// .content video{
//   width
// }
.ht{
  padding:5px 0px 5px 0px;
  box-shadow: 0px 0px 10px rgb(196, 198, 202);
  background-color: rgb(255, 255, 255);
  margin-bottom:20px;
  border-radius:30px 0px 0px 30px;
  
  @media screen and (max-width: 768px) {
    border-radius: 15px 0 0 15px;
  }
}
.html{
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 0px 10px rgb(196, 198, 202);
  min-height:650px;
  padding:10px 25px 10px 25px;
  // box-shadow: 0px 0px 25px rgb(168, 190, 244);
  margin-top:20px;
  margin-bottom: 20px;
  position: relative;
  z-index: 100;
  border-radius:10px;
  
  @media screen and (max-width: 768px) {
    padding: 10px 15px;
    min-height: 400px;
  }
}
.html video{
  width:100%;
}
.html img{
  width:100%;
}
.htmlTitle{
  text-align: center;
  font-size:40px;
  color:rgb(96, 95, 93);
  
  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
}
.htmlTime{
  font-size:15px;
  color:rgb(78, 77, 77);
  text-align: center;
  padding-bottom: 15px;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
}
.htmlBack{
  position:absolute;
  top:30px;
  left:25px;
  z-index: 200;
  
  @media screen and (max-width: 768px) {
    top: 15px;
    left: 10px;
    padding: 8px 12px;
  }
}
</style>